import { motion } from "framer-motion";
import video from "../img/hero.mp4";
import HeroText from "./HeroText";
import { useTheme } from "../context/ThemeContext";

export default function Hero() {
  const { mode } = useTheme();
  const isDark = mode === "dark";

  return (
    <section
      style={{
        minHeight: "60vh",
        height: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* 🎥 VIDEO */}
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",

          // 🔥 делаем максимально четким
          filter: "contrast(1.1) saturate(1.1)",
        }}
      >
        <source src={video} type="video/mp4" />
      </video>

      {/* 🔵 ЛЁГКИЙ СИНИЙ АКЦЕНТ (очень слабый) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at center, rgba(25,118,210,0.08), transparent 80%)",
        }}
      />

      {/* CONTENT */}
      <div
        style={{
          position: "relative",
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          height: "100%",
          padding: "0 16px",
          paddingTop: "10vh",

          // ❗ текст делаем контрастным
          color: isDark ? "#fff" : "#111",
          textShadow: "0 2px 10px rgba(0,0,0,0.4)", // 🔥 чтобы читалось без затемнения
        }}
      >
        <HeroText />
      </div>
    </section>
  );
}